import styled from 'styled-components';

import { Summary } from 'models/flexible/Summary';
import type { AdminSummaryShowFields } from 'services/api/fields';
import { colors } from 'styles/theme/colors';

export default function SourceList({
  summary,
}: {
  summary: Summary<AdminSummaryShowFields<'attachments' | 'aiArtifact'>>;
}) {
  if (!summary.attachments?.length) {
    return <EmptyText>No sources available</EmptyText>;
  }

  const sources = (summary.aiArtifact as any)?.data?.sources || summary.attachments;

  return (
    <StyledList>
      {sources.map((attachment: any, idx: number) => (
        <li key={attachment.id ?? idx}>
          <SourceName>{attachment.filename || attachment.blob?.filename || 'No filename'}</SourceName>
        </li>
      ))}
    </StyledList>
  );
}

const EmptyText = styled.p`
  color: ${colors.black50};
  font-style: italic;
`;

const StyledList = styled.ul`
  list-style-type: disc;
  margin-left: 20px;
  margin-top: 8px;
`;

const SourceName = styled.span`
  text-decoration: none;
  width: 100%;
  word-break: break-word;
`;
